"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  booking: {
    bookingJapan: {
      customerCode: '客商代码',
      customerNameCn: '客商中文名称',
      customerName: '客商英文名称',
      POR: '起始港',
      DEL: '目的港',
      radioDirect: '直达 ',
      radioTS: '中转',
      POLETD: '开航时间',
      PODETA: '抵港时间',
      searchButton: '查询',
      UsageMethod: '使用说明',
      UsageMethodText1: '显示以装港，卸港及ETD（A），服务类型为检索条件的船期。',
      UsageMethodText2: '可从检索结果页面直接订舱。',
      ShippingScheduleInquiry: '船期检索',
      ShippingScheduleInquiryText1: '请以装港，卸港及ETD（A），服务类型来检索船期。',
      ShippingScheduleInquiryText2: 'ETD，ETA和服务类型不为必选项。',
      Results: '检索结果页面',
      ResultsText: '按日期顺序显示船期。',
      Booking: '订舱',
      BookingText1: '点击预约后，进入订舱画面，录入订舱明细后，请点击送信。',
      BookingText2: 'SITC JAPAN的职员会尽快和您联系。',
      Scheduleresults: 'Schedule检索结果 ',
      FilterByVessel: '船名过滤',
      FilterByLane: '航线过滤',
      BookingButton: '订舱',
      POL: '装货港',
      POD: '卸货港',
      bookingStatus: '订舱状态',
      CREATEDTIME: '创建时间',
      From: '从',
      To: '到',
      BKGNO: '订舱号',
      BLNO: '提单号',
      exportButton: '导出',
      historyInfo1: '我们在预计离港时间（ETD）当天上午9点左右上传运费清单，如果您在预订时选择了勾选标记，我们将通过传真或邮件发送给您。在提单号的右侧将出现一个图标（￥）',
      historyInfo2: '您可以通过点击图标（￥）来打印或下载它。提单号在状态为“等待”或“待处理”时是临时的，一旦状态变为“已批准”，就确定了。',
      BookingHistory: '订舱历史',
      statusTable: 'STATUS',
      actionTable: 'ACTION',
      BkgNoTable: '订舱号',
      billTypeTable: 'BILL TYPE',
      blNotable: '提单号',
      vesselNameTable: '船名',
      voyNoTable: '航次',
      polTable: 'POL',
      etaTable: 'ETA',
      etdTable: 'ETD',
      podTable: 'POD',
      deltable: 'DEL',
      portAgentNameTable: '港口操作代理',
      TerminalNameTable: '码头名称',
      UpdateTimeTable: '修改时间',
      polWarning: '装货港不能为空',
      podWarning: '卸货港不能为空',
      selectWarning: '您尚未选择船名航次，请先选择！',
      resetButton: '重置',
      etdStrWarning: '开航时间不能为空',
      No: 'No',
      bookingHeadWebIdTable: 'bookingHeadWebId',
      feeFlagTable: 'feeFlag',
      lockStatusTable: 'lockStatus',
      voyageLegTable: 'voyageLeg',
      vesselCodeTable: 'vesselCode',
      ccaNoTable: 'ccaNo',
      freightMemoTable: '提单费用',
      tt3Table: 'tt3',
      submitTable: '提交',
      viewTable: '查看',
      changeTable: '修改',
      cancelTable: '取消',
      copyTable: 'Copy',
      vesselName: '船名',
      voyageNo: '航次',
      usedHours: '航行时间',
      serviceLineCode: '航线',
      xEnglishInfo: '',
      port: '場所'
    },
    bookingTemplate: {
      modelName: '模板名称',
      Portofdeparture: '起运港',
      Destinationport: '目的港',
      Bookingcontainertype: '订舱箱型',
      createTime: '创建时间',
      resetButton: '重置',
      searchButton: '查询',
      addTemplateButton: '新增模板',
      deleteSuccess: '删除成功',
      deleteConfirm: '确认删除？',
      deletTip: '提示',
      bookingButton: '立即订舱',
      editTemplateButton: '编辑模板',
      deleteTemplateButton: '删除模板'
    },
    bookingSplit: {
      applyBooking: '申请',
      vesselName: '船名',
      splistWanning3: '分报分出分票不允许再次分报分出',
      splistWanning4: '分报分出申请未被接受，无法进行拆并单。',
      splistWanning5: '该单为分报分出总单,不能进行拆并单',
      splistWanning6: '拆并单分票不允许再次拆并单。',
      spliteTitle0: '合报分出',
      spliteTitle1: '分报合出',
      spliteTitle3: '分报分出',
      splistWanningBooking: '仅支持 提单类型为普通的提单 或分出的主单 进行分报分出操作',
      splistCNSHA: '该功能仅支持蛇口和南沙使用',
      splistCntFlag: '仅支持 订舱状态=确认订舱/解锁/拆单申请 且 主分单都没有箱信息的订舱 进行自动确认！',
      splistMain1: '仅支持普通提单和拆单的主单进行拆单自动确认操作',
      splistCntFlag2: '仅支持 订舱状态=确认订舱/解锁/并单申请 且 主分单都没有箱信息的订舱 进行自动确认！',
      splistMain2: '仅支持 订舱状态=确认订舱/解锁/并单申请 且 主分单都没有箱信息的订舱 进行自动确认！',
      spliteCombinType0: '拆单补料',
      spliteCombinType1: '并单补料',
      splistWanningBooking1: '仅支持 提单类型为普通的提单 或 合报分出的主单 进行合报分出操作',
      repeatWarning1: '订舱号:',
      repeatWarning2: '重复,请重新输入',
      splistWanning10: '仅支持 订舱状态=确认订舱/解锁/并单申请 且 主分单都没有箱信息的订舱 进行自动确认！',
      splistChildrenWarning0: '仅支持普通提单和拆单的主单进行拆单自动确认操作！',
      splistChildrenWarning1: '仅支持普通提单和并单的主单进行并单自动确认操作！',
      repeatWarningBlNo1: '提单号:',
      repeatWarningBlNo2: '重复,请重新输入',
      splistWanningType3: '仅支持 提单类型为普通的提单 或 分报合出的主单 进行分报合出操作！',
      reportOutWarning: '仅支持 订舱状态=确认订舱/解锁/拆单申请 且 主分单都没有箱信息的订舱 进行自动确认',
      reportOutOneWarning: '仅支持 订舱状态=确认订舱/解锁/拆单申请 且 主分单都没有箱信息的订舱 进行自动确认',
      splitWarningOut1: '仅支持确认订舱、解锁、并单申请 状态的提单进行合报分出操作',
      splitWarningOut2: '仅支持确认订舱、解锁、并单申请 状态的提单进行分报合出操作',
      cancelWarning0: '仅支持拆单的主单取消拆单',
      cancelWarning1: '仅支持并单的主单取消并单',
      cancelWarning3: '仅支持分报分出的主单取消分报分出'
    },
    bookingHistroyJp: {
      customsBrokerWarning: "Company Name can not be empty!  <br/>" + "The information of Volume cannot be empty such as Gross Weight, Size, Quantity, Cargo Group etc.<br/>" + "Cargo Commodity can not be empty!",
      commodityCodeWaring: "The information of Volume cannot be empty such as Gross Weight, Size, Quantity, Cargo Group etc.<br/>" + "Cargo Commodity can not be empty!",
      grossWeightWarning: "Volume FCL Gross Weight can not be empty!<br/>" + "Cargo Commodity can not be empty!",
      cargoDescWarnng: 'Cargo Commodity can not be empty!',
      isSubmit: 'Apply Booking?',
      applyDownloadWarning: 'Please choose the record.',
      applyDownloadWarning2: "BK NO.:",
      applyDownloadWarning3: "<br/>Thers is no freight , please check.",
      webBkImosWarning: 'Hazardous Cargo can not be empty!',
      // webBkImosWarning: `Hazardous Cargo can not be empty!<br/>` +
      //   `Consignee Name can not be empty!`,
      webBkReefersWarning: 'Reffer can not be empty!',
      webBkAksWarning: 'Awkward Container can not be empty!',
      deliveryDocumentCompanyWarning: 'Consignee Name can not be empty!',
      cancenConfirm: 'Cancel Booking?'
    },
    bookingHistroryJpDetails: {
      PortofReceipt: '接货地：',
      POL: '装货港：',
      POD: '卸货港：',
      PortofDelivery: '目的地：',
      VESSELVOYAGE: '船名/航次：',
      POLETA: '抵港时间：',
      POLETD: '开航时间：',
      PODETA: '抵港时间：',
      Shipper: '发货人',
      Volume: '箱量',
      HazardousCargo: '危险品：',
      DGList: '不可接受的危险品清单',
      Payment: '付款方式：',
      ApproveKey: '快速审批密钥',
      ContactTypeCode: '通讯方式代码',
      ContactName: '联系人姓名',
      ContactNumber: '联系号码',
      Vent: '通风口',
      Temperature: '温度',
      Size: '尺寸(立方米)',
      saveSuccess: '保存成功',
      submitSuccess: '提交成功',
      dangerInfoTips: '(若为混载情况，请务必在备注信息描述详细情况。)',
      draftSaveButton: '保存草稿',
      confirmButton: '保存',
      backButton: '返回',
      submitButton: '提交',
      companyNameInfo: '所属机构:',
      telInfo: '电话:',
      e_mailInfo: '邮件地址:',
      contactInfo: '联系人:',
      faxInfo: '传真:',
      bookingDetailTitle: '订舱明细',
      faxNotNull: '传真不能为空'
    },
    blAgreementFr: {
      blNo: '提单号',
      ctnNo: '实际箱量',
      appStatus: '特价申请情况',
      active: '是否生效',
      freightCode: '特价协议号',
      vvl: '是否本船协议',
      applyNo: 'FT申请号',
      applyStatusFt: 'FT申请情况',
      activeFt: 'FT是否生效',
      vvlFt: '是否本船FT',
      applyDays: '申请天数',
      demuFreeDays: '申请天数/DEM',
      detenFreeDays: '申请天数/DET',
      manifestNoFt: '审批号',
      paidType: '付费方式',
      socCheckFlag: 'SOC',
      manifestNo: '舱单约号',
      fwd: '货代',
      vesselAndVoyageOrBlNoNotNull: '船名航次/提单号 不能为空！'
    }
  }
};